// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content_IrH21","area":"index_area_3vY8N","router":"index_router_1hXiO"};